import { useContext, useEffect, useState } from 'react';
import { Col, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import * as yup from 'yup';
import { CampoFormik } from '../../../components/CompUtils';
import es from '../../../yup-es';
import { cvTiposSelector } from '../cvSlice';
import { SeccionContext } from '../itemTypes';
import FormikContainer from './FormikContainer';

yup.setLocale(es);

//
// ─── SCHEMA INFORMATICOS ────────────────────────────────────────────────
//

const InformaticoSchema = yup.object({
  idConocimientoInformaticoCv: yup.number(),
  idDetalleTipoConocimientoInformatico: yup.string().required(),
  idNivelConocimientoInformatico: yup.number().required(),
  descripcion: yup.string().required(),
  institucion: yup.string().required(),
  idPais: yup.number(),
  f_certificacion: yup.date().required(),
});

//
// ─── FORMULARIO INFORMATICOS ──────────────────────────────────────────────────
//

export const FormInformatico = () => {
  const formState = useContext(SeccionContext);
  const extraData = useSelector(cvTiposSelector);
  const niveles = extraData.nivelInformatico;
  const tipos = extraData.tiposInformaticos;

  const [tipoSel, setTipoSel] = useState(tipos[1]);

  useEffect(() => {
    const initial = formState.initialValues.idDetalleTipoConocimientoInformatico || null;
    //tengo que setear el tipo informático de forma manual, no se guarda en el backend
    const idTipoSel = Object.keys(tipos).filter((key) => {
      return tipos[key].detalles.some(
        (det) => initial && initial === det.idDetalleTipoConocimientoInformatico,
      );
    })[0];
    setTipoSel(tipos[idTipoSel || 1]);
  }, [formState.initialValues, tipos]);

  return (
    <FormikContainer
      schema={InformaticoSchema}
      seccionKey="informaticos"
      seccionTitle="Conocimientos informáticos">
      {(formik) => (
        <>
          <Form.Row>
            {/* Select de tipo de conocimiento */}
            <Form.Group as={Col}>
              <Form.Label for="categoria">Categoría (obligatorio):</Form.Label>
              <Form.Control
                aria-required
                id="categoria"
                as="select"
                name="tipoConocimiento"
                value={tipoSel.id}
                onChange={(val) => setTipoSel(tipos[val.target.value])}>
                {Object.keys(tipos).map((key, idx) => (
                  <option value={tipos[key].id} key={tipos[key].id}>
                    {tipos[key].nombre}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            {/* Select del detalle de conocimiento   */}
            <Form.Group as={Col}>
              <Form.Label for="conocimiento">Conocimiento (obligatorio):</Form.Label>
              <Form.Control
                aria-required
                id="conocimiento"
                as="select"
                name="idDetalleTipoConocimientoInformatico"
                onChange={(ev) => {
                  const detalle = tipoSel.detalles.find(
                    (el) => el.idDetalleTipoConocimientoInformatico === parseInt(ev.target.value),
                  );
                  formik.setFieldValue('descripcion', detalle?.nombre);
                  formik.setFieldValue(
                    'idDetalleTipoConocimientoInformatico',
                    detalle?.idDetalleTipoConocimientoInformatico,
                  );
                }}
                value={formik.values.idDetalleTipoConocimientoInformatico}
                onBlur={formik.handleBlur}
                isInvalid={
                  formik.touched.idDetalleTipoConocimientoInformatico &&
                  !!formik.errors.idDetalleTipoConocimientoInformatico
                }>
                <option value="">Seleccione</option>
                {tipoSel.detalles.map((el, idx) => (
                  <option
                    key={idx}
                    value={el.idDetalleTipoConocimientoInformatico}
                    title={el.descripcion}>
                    {el.nombre}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {formik.errors.idDetalleTipoConocimientoInformatico}
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            {/* Select de nivel de conocimiento */}
            <Form.Group as={Col}>
              <Form.Label for="nivel">Nivel (obligatorio):</Form.Label>
              <Form.Control
                aria-required
                id="nivel"
                as="select"
                name="idNivelConocimientoInformatico"
                value={formik.values.idNivelConocimientoInformatico}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={
                  formik.touched.idNivelConocimientoInformatico &&
                  !!formik.errors.idNivelConocimientoInformatico
                }>
                <option value="">Seleccione</option>
                {Object.keys(niveles).map((key, idx) => (
                  <option value={niveles[key].id} key={idx}>
                    {niveles[key].nombre}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {formik.errors.idNivelConocimientoInformatico}
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <CampoFormik
              aria-required
              name="institucion"
              label="Institución o establecimiento (obligatorio)"
              formik={formik}
            />
          </Form.Row>
          <Form.Row>
            <CampoFormik
              type="pais"
              label="País (obligatorio)"
              name="idPais"
              optional
              formik={formik}
            />
          </Form.Row>
          <Form.Row>
            <CampoFormik
              aria-required
              col={{ sm: 4 }}
              type="date"
              name="f_certificacion"
              label="Fecha de certificación (obligatorio)"
              formik={formik}
            />
          </Form.Row>
        </>
      )}
    </FormikContainer>
  );
};
